/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-13 14:58:37
 * @LastEditTime : 2025-05-13 14:59:21
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\contractManageApi.js
 */
/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-28 15:11:45
 * @LastEditors: 刘小二
 * @LastEditTime: 2024-07-22 08:59:20
 * @Description: 合同管理
 * @FilePath: /xxps/src/api/contractManageApi.js
 */
import request from '@/utils/request'


/* *****************合同管理******************/
// 合同分页
export function getContractPage(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/contractPage',
		method: 'post',
		data
	})
}
// 合同分页
export function getContract(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/contractInfos',
		method: 'post',
		data
	})
}
// 获取物品合同单价
export function getContractUintPrice(data) {
	return request({
		url: '/grasspond/business-warehousing-apply/getContractUintPrice',
		method: 'post',
		data
	})
}
// 根据id删除采购合同物品信息
export function delMaterialByid(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_material_byid/${id}`,
		method: 'get'
	})
}
// 批量禁用
export function editBatchStatusOff(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/edit_batch_status_off',
		method: 'post',
		data
	})
}
// 批量禁用
export function editBatchStatusOn(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/edit_batch_status_on',
		method: 'post',
		data
	})
}
// 导入合同材料采购明细
export function inputPurchases(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/input_purchases',
		method: 'post',
		data
	})
}
// 导出采购合同
export function outputPurchase(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/output_purchase',
		method: 'post',
		data
	})
}
// 导出模板
export function outputTem() {
	return request({
		url: '/grasspond/business-contract-basic-information/output_tem',
		method: 'get'
	})
}
// 新增合同
export function saveContract(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/saveContract',
		method: 'post',
		data
	})
}
// 合同-新增明细客户
export function alterContractProfitCenter(data) {
	return request({
		url: '/grasspond/business-contract-basic-information/alterContractProfitCenter',
		method: 'post',
		data
	})
}
// 根据id获取采购合同
export function getContractMaterialByid(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_contract_material_byid/${id}`,
		method: 'get'
	})
}
// 根据id删除基建详情
export function delCharaterById(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_charater_byid/${id}`,
		method: 'get'
	})
}
// 根据id删除安装详情
export function delInstallById(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_install_byid/${id}`,
		method: 'get'
	})
}
// 根据id删除运输类型合同详情
export function del_trans_type_byid(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_trans_type_byid/${id}`,
		method: 'get'
	})
}
// 根据id删除运输里程合同详情
export function del_trans_km_byid(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_trans_km_byid/${id}`,
		method: 'get'
	})
}
// 根据id删除运输转运合同详情
export function del_transfer_byid(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_transfer_byid/${id}`,
		method: 'get'
	})
}
// 根据id删除非制造采购-销售详情
export function delNomakeById(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_nomake_byid/${id}`,
		method: 'get'
	})
}
//根据id获取非制造合同调价记录
export function getByidAdjusts(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_byid_adjust/${id}`,
		method: 'get'
	})
}
// 根据调价id获取非制造调价详情
export function getByidAdjustDetails(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_byid_adjust_detail/${id}`,
		method: 'get'
	})
}
// 非制造合同新增调价
export function addContractAdjusts(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/add_contract_adjust`,
		method: 'post',
		data
	})
}
// 非制造合同编辑调价
export function editContractAdjusts(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/edit_contract_adjust`,
		method: 'post',
		data
	})
}
// 根据id删除非制造合同调价
export function delContractAdjusts(id,upId) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_contract_adjust/${id}/${upId}`,
		method: 'get'
	})
}
// 导出材料采购模板
export function output_material_tem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_material_tem`,
		method: 'get'
	})
}
// 导出非制造采购-销售模板
export function output_nomake_tem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_nomake_tem`,
		method: 'get'
	})
}
// 导入合同材料采购明细
export function getSecondContract(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_second_contract?secondPartyName=${data}`,
		method: 'get'
	})
}
// 导出销售合同
export function outputSales(data) {
	return request({
		// url: '/grasspond/business-contract-basic-information/output_sale',
		url: '/grasspond/business-contract-basic-information/exportContract',
		method: 'post',
		data
	})
}

// 导出材料采购模板
export function output_Sale_tem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_sale_tem`,
		method: 'get'
	})
}
// 劳务合同需要的产品
export function getProductType() {
	return request({
		url: `/grasspond/business-product-manage/get_product_type`,
		method: 'get'
	})
}
// 获取所有销售合同
export function getAllContract() {
	return request({
		url: `/grasspond/business-contract-basic-information/get_all`,
		method: 'get'
	})
}
// 根据财务编码获取合同
export function getFinanceCodeContract(params) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_finance_code_contract`,
		method: 'get',
		params
	})
}
// 导出基建采购模板
export function outputCharaterTem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_charater_tem`,
		method: 'get'
	})
}
// 导出安装采购模板
export function outputInstallTem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_install_tem`,
		method: 'get'
	})
}

// 导出其它业务模板
export function outputOtherTem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_other_tem`,
		method: 'get'
	})
}


// 导出检测试验合同
export function outputCheckTem() {
	return request({
		url: `/grasspond/business-contract-basic-information/output_check_tem`,
		method: 'get'
	})
}

// 根据甲方获取合同
export function getFirstToContract(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_first_contract`,
		method: 'post',
		data
	})
}

// 根据甲方及合同类型获取合同
export function getFirstContractTypes(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_first_contract_types`,
		method: 'post',
		data
	})
}

// 根据乙方获取合同
export function getSecondToContract(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_second_to_contract`,
		method: 'post',
		data
	})
}
/** ----------------销售合同调价一系列 ------------------------------------------------*/
// 根据合同id获取调价记录
export function getByidAdjust(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_byid_adjust/${id}`,
		method: 'get'
	})
}
// 根据调价id获取调价详情
export function getByidAdjustDetail(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_byid_adjust_detail/${id}`,
		method: 'get'
	})
}
// 销售合同新增调价
export function addContractAdjust(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/add_contract_adjust`,
		method: 'post',
		data
	})
}
// 销售合同新增调价
export function editContractAdjust(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/edit_contract_adjust`,
		method: 'post',
		data
	})
}
// 根据id删除调价
export function delContractAdjust(id,upId) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_contract_adjust/${id}/${upId}`,
		method: 'get'
	})
}
// 根据id删除主合同
export function delContract(id,val) {
	return request({
		url: `/grasspond/business-contract-basic-information/del_contract/${id}/${val}`,
		method: 'get'
	})
}

// 获取合同获取客户(甲方)
export function getAllContractFirst(params) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_all_contract_first`,
		method: 'get',
    params
	})
}
// 获取合同获取供应商(乙方)
export function getAllContractSecond(params) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_all_contract_second`,
		method: 'get',
    params
	})
}
// 销售合同销售人员修改
export function editContractSalesUser(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/edit_sales_user`,
		method: 'post',
		data
	})
}

// 销售合同销售人员修改
export function editContractSalesUserLog(id) {
	return request({
		url: `/grasspond/business-sales-track-log/get_project_progress/${id}`,
		method: 'get',
	})
}

// 新增销售合同付款方式
export function saveContractPayTypeInfo(data) {
	return request({
		url: `/grasspond/business-contract-basic-information/save_three`,
		method: 'post',
		data
	})
}

// 销售合同付款方式
export function getContractPayTypeInfoID(id) {
	return request({
		url: `/grasspond/business-contract-basic-information/get_three_byid/${id}`,
		method: 'get',
	})
}

//老合同状态提交/修改
export function updateOldContractStatus(data) {
  return request({
    url: `/grasspond/business-contract-basic-information/edit_batch_status_old`,
    method: 'post',
    data
  })
}
